import React from 'react';

const AssessmentContent = ({children, className = ''}) => (
    <div className={`assessment-content ${className}`}>
        <div style={{width: '100%'}}>
            {children}
        </div>
    </div>
)

export default AssessmentContent;